<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4">
        <CCard class="pb-3">
          <CCardHeader class="d-flex justify-content-between">
            <span><i class="fas fa-store"></i>&nbsp;Venta</span>
            <button
              @click="returnHome"
              type="button"
              class="btn btn-sm text-white"
              style="background: #e46666"
            >
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </CCardHeader>
          <template v-if="popularProducts.length > 0">
            <CCardBody
              v-for="(item, index) in popularProducts"
              :key="index"
              class="container-card-body mt-3 mx-3"
              @click="addPopularProduct(item)"
              :class="item.stock == 0 ? '' : 'bg-info'"
            >
              <CRow>
                <CCol
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  class="d-flex justify-content-between font-bold"
                >
                  <div>{{ item.label }}</div>
                  <div>Precio: {{ item.price }}</div>
                </CCol>
              </CRow>
            </CCardBody>
          </template>
          <template v-else>
            <CCardBody class="text-center">
              <h4>AUN NO CUENTA CON PRODUCTOS VENDIDOS</h4>
            </CCardBody>
          </template>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="8">
        <CCard>
          <CCardHeader class="d-flex justify-content-between responsive">
            <span><i class="fas fa-coins"></i>&nbsp;Producto</span>
            <div class="d-flex flex-wrap">
              <div class="font-bold responsive-font mr-lg-3 mr-md-2 mr-sm-1">
                <b>Total S/{{ calculateTotal.toFixed(2) }}</b>
              </div>
              <button
                type="button"
                class="btn btn-sm text-white"
                style="background: #39f; margin-right: 10px"
                @click="mtdOpenModalSale"
                :disabled="productList.length == 0"
              >
                <i class="fas fa-dollar-sign"></i>
                <b>Terminar Venta</b>
              </button>
              <button
                type="button"
                class="btn btn-sm text-white"
                style="background: #30d5c8"
                @click="mtdOpenQuotes"
                :disabled="productList.length == 0"
              >
                <i class="fas fa-dollar-sign"></i>
                <b>Cotizacion</b>
              </button>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12" md="12" lg="5" xl="5">
                <CInput
                  label="Código de Producto"
                  placeholder="Digite de barras mediante la lectora"
                  v-model="searchBarcode"
                  @keypress.enter="filterProductoBarcode"
                />
              </CCol>
              <CCol sm="9" md="10" lg="5" xl="5" class="col-9">
                <CInput
                  label="Buscar Producto"
                  type="search"
                  v-model="searchQuery"
                  @keypress.enter="filterProducts"
                  placeholder="Digite nombre de producto.."
                />
              </CCol>
              <CCol sm="3" md="2" lg="2" xl="2" class="mt-1 my-auto mx-0 col-3">
                <CButton
                  class="w-100 mt-2"
                  color="info"
                  v-c-tooltip.hover="{ content: `Buscar producto` }"
                  @click="filterProducts"
                >
                  <i class="fas fa-search"></i>
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardHeader class="d-flex justify-content-start">
            <span><i class="fa fa-store"></i>&nbsp; Detalle de venta </span>
          </CCardHeader>
          <CCardBody>
            <div class="table-responsive">
              <table
                id="dataTableLists"
                class="table table-sm table-hover table-bordered dt-responsive nowrap"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th width="20">N°</th>
                    <th>Producto</th>
                    <th>Unidad</th>
                    <th>Stock</th>
                    <th>Precio</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(product, index) in productList"
                    :key="index"
                    style="cursor: pointer"
                  >
                    <td @click="openProductModal(product)">{{ index + 1 }}</td>
                    <td @click="openProductModal(product)">
                      {{ product.product.name }}
                    </td>
                    <td @click="openProductModal(product)">
                      {{ product.unit.name }}
                    </td>
                    <td @click="openProductModal(product)" class="text-center">
                      {{
                        product.stock ? parseInt(product.stock) : product.stock
                      }}
                    </td>
                    <td @click="openProductModal(product)" class="text-right">
                      {{ product.price }}
                    </td>
                    <td @click="openProductModal(product)" class="text-center">
                      {{ product.quantity }}
                    </td>
                    <td @click="openProductModal(product)" class="text-right">
                      {{ (product.price * product.quantity).toFixed(2) }}
                    </td>
                    <td class="text-center">
                      <button
                        @click.stop="removeProduct(index)"
                        class="btn btn-danger btn-sm"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="container mx-auto">
      <!-- Existing content -->
      <cModalSale
        :title="modalSale.title"
        :productList="productList"
        :sale="sale"
        :boo_modal="modalSale.modal_form"
        @closeModalSale="closeModalSale"
        @save="handleSave"
      />

      <cModalUpdateSale
        :title="modalUpdateSale.title"
        :boo_modal="modalUpdateSale.modal_form"
        :product="modalUpdateSale.product"
        @closeModalUpdateSale="closeModalUpdateSale"
        @updateProduct="handleUpdateProduct"
        :data_product="data_product"
      />

      <cModalProductList
        :products="filteredProducts"
        :boo_modal="modalProductList.modal_form"
        @close="closeProductListModal"
        @selectProduct="selectProduct"
        @selectProductList="selectProductList"
      />

      <cModalQuotes
        ref="cQuotes"
        :title="modalQuotes.title"
        :boo_modal="modalQuotes.modal_form"
        :sale="sale"
        @mtdClose="closeModalQuotes"
        @save="saveQuotes"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import cModalSale from "../modals/cModalSale.vue";
import cModalUpdateSale from "../modals/cModalUpdateSale.vue";
import cModalProductList from "../modals/cModalProductList.vue";
import cModalQuotes from "../modals/cModalQuotes.vue";
export default {
  name: "sales",
  components: {
    cModalSale,
    cModalUpdateSale,
    cModalProductList,
    cModalQuotes,
  },
  data() {
    return {
      prefix: "sales",
      data_product: [],
      estado: true,
      searchQuery: "", // Para almacenar lo que escribe el usuario
      searchBarcode: "", // Para almacenar lo que escribe el usuario
      filteredProducts: [], // Para almacenar los productos filtrados
      filteredProductsBarcode: [], // Para almacenar los productos filtrados
      productList: [],
      popularProducts: [],
      sale: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        date: "",
        method: "",
        type: "",
        total: 0 /** monto total del servicio */,
        amount: 0 /**monto pagado - adelanto */,
        pending: 0 /** pendiente */,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        entity_obs: "",
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        option: 0,
      },
      newProduct: {
        product: {
          id: "",
          name: "",
        },
        price: "",
        quantity: 1,
        subtotal: 0,
        stock: 0,
        stocks: null,
        type: 0, // tipo 3: producto producido
        is_production: false,
        production_id: 0
      },
      modalSale: {
        title: "Terminar Venta",
        modal_form: false,
      },
      modalUpdateSale: {
        title: "Editar",
        modal_form: false,
        product: {
          product: {
            id: "",
            name: "",
          },
          price: "",
          quantity: "",
          subtotal: "",
          code: "",
          stocks: null,
        },
      },
      modalProductList: {
        modal_form: false,
      },
      modalQuotes: {
        title: "COTIZACIÓN",
        modal_form: false,
      },
    };
  },
  computed: {
    calculateSubtotal() {
      return (this.newProduct.subtotal =
        this.newProduct.price * this.newProduct.quantity);
    },
    calculateTotal() {
      return this.productList.reduce((total, product) => {
        return total + product.price * product.quantity;
      }, 0);
    },
    cpButton() {},
  },
  watch: {
    productList: {
      handler() {
        this.sale.total = this.calculateTotal.toFixed(2);
      },
      deep: true,
    },
  },
  created() {
    this.showProduct();
    this.showPopularProducts();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    showPopularProducts() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byPopularProducts/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const stockMap = new Map();

          // Mapeo de stock por product_unit_id para acceso rápido
          response.data.stock.forEach(({ product_unit, stock, stocks }) => {
            stockMap.set(product_unit.id, {
              productName: product_unit.product.name,
              productId: product_unit.product.id,
              unitName: product_unit.unit.name,
              unitId: product_unit.unit.id,
              price: product_unit.product.price[0].sale_price,
              stock: stock,
              stocks: stocks,
            });
          });

          // Construcción de popularProducts combinando la información del stock y popular
          response.data.popular.forEach(
            ({ product_unit_id, total_quantity }, index) => {
              if (index < 7) {
                const stockInfo = stockMap.get(product_unit_id);
                if (stockInfo) {
                  this.popularProducts.push({
                    label: stockInfo.productName,
                    value: stockInfo.productId,
                    label_unit: stockInfo.unitName,
                    value_unit: stockInfo.unitId,
                    price: stockInfo.price,
                    quantity: total_quantity,
                    stock: stockInfo.stock,
                    stocks: stockInfo.stocks,
                  });
                }
              }
            }
          );
          this.popularProducts = this.popularProducts.slice(0, 7);
        })
        .catch((errors) => {});
    },
    showProduct() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byProduct/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // console.log(response.data.data);

          /* response.data.data.forEach((arr) => {
            const { stock, product_unit, is_production } = arr;
            this.data_product.push({
              label: product_unit.product.name,
              value: product_unit.product.id,
              price: product_unit.product.price[0].sale_price,
              value_unit: product_unit.unit.id,
              label_unit: product_unit.unit.name,
              barcodes: product_unit.product.barcode,
              stock: stock,
              type: is_production ? 3 : 1, // 1: producto normal, 3: producto producido
              is_production: is_production || false
            });
          }); */

          response.data.data.forEach((arr) => {
            const { stock, product_unit, is_production, production, stocks } = arr;

            if (is_production && production) {
              // Producto producido
              this.data_product.push({
                label: production.name,
                value: production.id,
                price: production.price,
                value_unit: 1, // UND por defecto
                label_unit: 'UND',
                barcodes: [],
                stock: stock,
                stocks: stocks,
                type: 3, // tipo 3: producto producido
                is_production: true,
                production_id: production.id
              });
            } else if (product_unit && product_unit.product) {
              // Producto normal
              this.data_product.push({
                label: product_unit.product.name,
                value: product_unit.product.id,
                price: product_unit.product.price[0].sale_price,
                value_unit: product_unit.unit.id,
                label_unit: product_unit.unit.name,
                barcodes: product_unit.product.barcode || [],
                stock: stock,
                stocks: stocks,
                type: 1, // tipo 1: producto normal
                is_production: false,
                product_unit_id: product_unit.id
              });
            }
          });

          /** kit */
          response.data.kit.forEach((arr) => {
            this.data_product.push({
              label: arr.name,
              value: arr.id,
              price: arr.price,
              value_unit: 1,
              label_unit: "Unidad",
              barcodes: "",
              stock: 0,
              detail: arr.detail,
              type: 2, // kit
            });
          });
        })
        .catch((errors) => {});
    },
    filterProducts() {
      if (this.searchQuery) {
        this.filteredProducts = this.data_product.filter((product) =>
          product.label.toLowerCase().includes(this.searchQuery.toLowerCase())
        );

        if (this.filteredProducts.length > 0) {
          this.modalProductList.modal_form = true;
        } else {
          Swal.fire({
            title: "Producto no registrado ",
            icon: "warning",
          });
        }
      }
    },
    selectProduct(product) {
      this.searchQuery = "";
      // const existingProduct = this.productList.find(
      //   (p) =>
      //     p.product.id === product.value && p.unit.id === product.value_unit
      // );
      const existingProduct = this.productList.find(
        (p) =>
          p.product.id === product.value &&
          p.unit.id === product.value_unit &&
          p.product.name === product.label &&
          p.is_production === product.is_production
      );

      if (existingProduct) {
        // If the product exists, increment its quantity
        // if (existingProduct.quantity < product.stock) {
        //   existingProduct.quantity += 1;
        // }
        existingProduct.quantity += 1;
      } else {
        // If the product doesn't exist, add it to the list
        const newProduct = {
          product: {
            id: product.value,
            name: product.label,
          },
          unit: {
            id: product.value_unit,
            name: product.label_unit,
          },
          price: product.price,
          quantity: 1,
          subtotal: product.price,
          stock: product.stock,
          stocks: product.stocks,
          kit: null,
          type: product.type,
          is_production: product.is_production || false,
          production_id: product.production_id || null,
          product_unit_id: product.product_unit_id || null
        };
        this.productList.push(newProduct);
      }

      // Close the modal after selection
      this.closeProductListModal();
    },
    selectProductList(lst) {
      lst.detail.forEach((product) => {
        this.searchQuery = "";
        const existingProduct = this.productList.find(
          (p) =>
            p.product.id === product.value && p.unit.id === product.value_unit
        );
        if (existingProduct) {
          existingProduct.quantity += 1;
        } else {
          const newProduct = {
            product: {
              id: product.product_unit.product.id,
              name: lst.label + "-" + product.product_unit.product.name,
            },
            unit: {
              id: product.product_unit.unit.id,
              name: product.product_unit.unit.name,
            },
            price: product.price,
            quantity: parseInt(product.quantity),
            subtotal: product.price,
            stock: product.stock,
            kit: lst.value,
          };
          this.productList.push(newProduct);
        }
      });
      this.closeProductListModal();
    },
    closeProductListModal() {
      this.modalProductList.modal_form = false;
    },
    removeProduct(index) {
      // this.productList.splice(index, 1);
      Swal.fire({
        title: "¿Desea eliminar el producto?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          // Si el usuario confirma, se elimina el producto
          this.productList.splice(index, 1);
          Swal.fire("Eliminado!", "El producto ha sido eliminado.", "success");
        }
      });
    },
    addPopularProduct(item) {
      const existingProduct = this.productList.find(
        (product) => product.product.name === item.label &&
          product.is_production === (item.is_production || false)
      );

      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        const productToAdd = {
          product: {
            id: item.value, // Use item.value for the ID
            name: item.label,
          },
          unit: {
            id: item.value_unit,
            name: item.label_unit,
          },
          price: item.price,
          quantity: 1,
          subtotal: item.price,
          stock: item.stock,
          stocks: item.stocks,
          kit: null,
          type: item.type || 1,
          is_production: item.is_production || false,
          production_id: item.production_id || null,
          product_unit_id: item.product_unit_id || null
        };
        this.productList.push(productToAdd);
      }
    },
    // Existing methods
    handleSave() {
      // Restablecer la lista de productos y la venta después de guardar
      this.productList = [];
      this.sale = {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        date: "",
        method: "",
        type: "",
        total: 0 /** monto total del servicio */,
        amount: 0 /**monto pagado - adelanto */,
        pending: 0 /** pendiente */,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        option: 0,
        entity_obs: "",
      };
      this.modalSale.modal_form = false;

      //limpio datos
      this.data_product = [];
      this.popularProducts = [];
      //recargo denuevo
      this.showProduct();
      this.showPopularProducts();
    },
    mtdOpenModalSale() {
      this.modalSale = {
        title: "TERMINAR VENTA",
        modal_form: true,
      };
    },
    closeModalSale() {
      this.modalSale = {
        modal_form: false,
      };
      this.sale.entity_document = "";
      this.sale.entity_name = "";
    },
    openProductModal(product) {
      this.modalUpdateSale = {
        title: "Editar",
        modal_form: true,
        product: product,
      };
    },
    closeModalUpdateSale() {
      this.modalUpdateSale = {
        modal_form: false,
      };
    },
    handleUpdateProduct(updatedProduct) {
      const index = this.productList.findIndex(
        (p) => p.product.id === updatedProduct.product.id
      );
      if (index !== -1) {
        this.$set(this.productList, index, updatedProduct); // Actualiza el producto en la lista
      }
    },
    filterProductoBarcode() {
      if (this.searchBarcode) {
        // Filtrar los productos que coinciden con el código de barras
        this.filteredProductsBarcode = this.data_product.filter((product) =>
          product.barcodes.some(
            (barcode) => barcode.name === this.searchBarcode
          )
        );

        // Si se encuentran productos coincidentes, ejecutar la función para agregarlos
        if (this.filteredProductsBarcode.length > 0) {
          this.addProductoBarcode(this.filteredProductsBarcode);
        } else {
          Swal.fire({
            title: "Código de barra no encontrada",
            icon: "warning",
          });
        }
      }
    },
    addProductoBarcode(product) {
      const prod = product[0];
      const existingProduct = this.productList.find(
        (p) => p.product.id === prod.value && p.unit.id === prod.value_unit
      );

      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        // If the product doesn't exist, add it to the list
        const newProduct = {
          product: {
            id: prod.value,
            name: prod.label,
          },
          unit: {
            id: prod.value_unit,
            name: prod.label_unit,
          },
          price: prod.price,
          quantity: 1,
          subtotal: prod.price,
          stock: prod.stock,
        };
        this.productList.push(newProduct);
      }
    },
    //Cotizacion
    mtdOpenQuotes() {
      if (this.productList.length == 0) {
        Swal.fire({
          title: "Agregue un Producto al Carrito",
          icon: "warning",
        });
      } else {
        this.modalQuotes = {
          title: "COTIZACIÓN",
          modal_form: true,
        };
      }
    },
    closeModalQuotes() {
      this.modalQuotes = {
        title: "COTIZACIÓN",
        modal_form: false,
      };
    },
    saveQuotes(data, total, pagoTotal,client) {
      this.post({
        url: this.$store.getters.get__url + "/quotes/store",
        token: this.$store.getters.get__token,
        params: {
          data: data,
          total: total,
          pagoTotal: pagoTotal,
          products: this.productList,
          company_id: this.$store.getters.get_company.id,
          campu_id: this.$store.getters.get_campu.id,
          user_id: this.$store.getters.get__user_id,
        },
      })
        .then((response) => {
          console.log(response);

          if (response.statusCode == 200) {
            Swal.fire({
              title: "Registrado Correctamente",
              icon: "success",
            });
            this.mtdProccessSaleResponse(response,client.name ,client.document, "");
            // this.viewpdfQuotes(response.data.id);
            this.productList = [];
            this.$nextTick(() => {
              if (this.$refs.cQuotes && this.$refs.cQuotes.mtdClear) {
                this.$refs.cQuotes.mtdClear();
              }
            });
            this.closeModalQuotes();
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "error",
          });
        });
    },
    viewpdfQuotes: function (id) {
      window.open(
        this.$store.getters.get__url + "/viewpdfQuotes/" + id,
        "_blank"
      );
    },
    mtdProccessSaleResponse: async function (response, name, document, phone) {
      const result = await Swal.fire({
        title: "Cotización Finalizada",
        text: "Seleccione una opción",
        icon: "success",
        showCancelButton: true,
        showDenyButton: false,
        confirmButtonText: '<i class="fas fa-file-pdf"></i> Imprimir PDF',
        cancelButtonText: '<i class="fab fa-whatsapp"></i> Enviar a WhatsApp',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-success",
          actions: "d-flex justify-content-between gap-2",
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: true,
        showCloseButton: true,
      });
      if (result.isConfirmed) {
        this.viewpdfQuotes(response.data.id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // let phone = celular;
        if (!phone) {
          await Swal.fire({
            title: "No hay número registrado",
            text: "Por favor, ingresa un número de teléfono para enviar el comprobante.",
            icon: "warning",
            input: "text",
            inputPlaceholder: "Ingrese su número de teléfono",
            showCancelButton: true,
          }).then(async (inputResult) => {
            if (inputResult.isConfirmed && inputResult.value) {
              phone = inputResult.value;
            } else {
              return;
            }
          });
        } else {
          await Swal.fire({
            title: "Confirmar número de teléfono",
            text: "Por favor, revisa o edita el número de teléfono antes de enviar el comprobante.",
            icon: "info",
            input: "text",
            inputValue: phone,
            showCancelButton: true,
          }).then(async (inputResult) => {
            if (inputResult.isConfirmed && inputResult.value) {
              phone = inputResult.value;
            } else {
              return;
            }
          });
        }
        let urlPdf = this.$store.getters.get__url + "/viewpdfQuotes/" + response.data.id;
        await this.post({
          url: this.$store.getters.get__url + "/send/wsp/sale",
          token: this.$store.getters.get__token,
          params: {
            phone: phone,
            fileUrl: urlPdf,
            filename: `cotizacion-${response.data.id}.pdf`,
            message: `Hola ${name}, te enviamos el comprobante de cotizacion en *AQ Industrias*. \nGracias por tu preferencia. \n¡Quedamos atentos para cualquier consulta!.\nSaludos`,
            document: document
          },
        });

        await Swal.fire({
          title: "Mensaje enviado",
          text:
            "El comprobante electrónico se ha enviado correctamente a " + phone,
          icon: "success",
        });
      }
    },
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.bg-gray {
  background-color: #dee2e6;
}

.bg-green {
  background-color: #28a745;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-card-body {
  background-color: #dee2e6;
  border-radius: 8px;
  cursor: pointer;
}

.lista {
  background-color: #ebedef;
  border-radius: 6px;
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin-top: -10px;
}

.lista li {
  width: 100%;
  padding: 2px 0 2px 10px;
}

.lista li:hover {
  border-radius: 6px;
  background-color: #39f;
  list-style-type: none;
  color: #fff;
}

.table-responsive {
  overflow-x: auto;
}

.responsive-font {
  font-size: 1rem;
}

.responsive {
  flex-direction: row;
}

@media (min-width: 300px) {
  /* sm */
  .responsive {
    flex-direction: column;
  }
}

@media (min-width: 576px) {
  /* sm */
  .responsive-font {
    font-size: 1.25rem;
  }
}

@media (min-width: 768px) {
  /* md */
  .responsive-font {
    font-size: 1.4rem;
  }

  .responsive {
    flex-direction: row;
  }
}

@media (min-width: 992px) {
  /* lg */
  .responsive-font {
    font-size: 1.4rem;
  }
}
</style>
